import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose, Dispatch } from 'redux';
import { translate } from 'react-i18next';

import OutageNotificationDetail from './outageNotificationDetail';
import { createOutageNotification } from '../../actions/outageNotificationActions';
import { navigateToOutageNotifications } from '../../actions/navigationActions';
import * as enums from '../../common/enums';
import OutageNotification from '../../entities/outageNotification';
import { BaseDetailDispatchProps, BaseDetailProps } from '../common/types/baseDetail';

const initialValues = new OutageNotification({
    name: '',
    filter: enums.OUTAGE_NOTIFICATION_FILTER_TYPE_ENUM.NONE,
    platform: enums.PLATFORMA_TYPES_ENUM.ALL,
    order: 0,
});

interface OutageNotificationDetailCreateProps extends BaseDetailProps<OutageNotification> {}

const OutageNotificationDetailCreate = ({ submitAction, cancelAction, t }: OutageNotificationDetailCreateProps) => {
    return (
        <OutageNotificationDetail
            t={t}
            initialValues={initialValues}
            submitAction={submitAction}
            headerText={t('CreateOutageNotification')}
            cancelAction={cancelAction}
        />
    );
};

const mapDispatchToProps = (dispatch: Dispatch<any>): BaseDetailDispatchProps<OutageNotification> => {
    return {
        submitAction: bindActionCreators(createOutageNotification, dispatch),
        cancelAction: bindActionCreators(navigateToOutageNotifications, dispatch),
    };
};

export default compose(connect(undefined, mapDispatchToProps), translate('common'))(OutageNotificationDetailCreate);
